import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CoreService } from 'src/app/core/services/core.service';
import { ManageUsersService } from 'src/app/modules/manage-users/services/manage-users.service';
import { DASHBOARD_URL, MANAGE_WORKFLOWS_URL, NOTIFICATION_ERROR } from '../../constants/constant';
import { ERROR_OCCURED_TRY_AGAIN_LATER } from '../../constants/messages';
import { NotificationAlert } from '../../models/notificationAlert.model';
import { UserFileUploadDetails, UserFileDownload } from '../../models/userDetail.model';
import { base64ToArrayBuffer, saveByteArray } from '../../utilities/util';
import { TableGridHeader } from '../table-grid/table-grid.model';

@Component({
  selector: 'app-view-upload',
  templateUrl: './view-upload.component.html',
  styleUrls: ['./view-upload.component.scss']
})
export class ViewUploadComponent implements OnInit {

  public alert: NotificationAlert = null;
  public fileUploadHeaders: TableGridHeader[];
  public documentFiles: UserFileUploadDetails[];
  public popupMessage: string;
  public loginID: number;
  showBackCPQPNavigationButton: boolean;

  constructor(
    private route: ActivatedRoute,
    private manageUsersService: ManageUsersService,
    private router: Router
  ) {
    if(this.route && this.route.parent) {
      this.route.parent.params.subscribe(params => {
        this.loginID = params.id;
      });
    }

    if(this.router.url.includes(MANAGE_WORKFLOWS_URL)) {
      this.showBackCPQPNavigationButton = true;
    }
   }

  ngOnInit(): void {
    this.getFileUploadList();
    this.fileUploadHeaders = [
      {
        name: 'Document',
        key: 'fileTypeCodeName',
        sortType: 'string',
        type: 'string',
      },
      { name: 'Document upload', key: 'fileName', sortType: 'string', type: 'string' },
      { name: 'Date' , key: 'updatedOn' , sortType: 'date' , type : 'date'},
      { name: '' , key : '' , type: 'download-button'},
    ];
  }

  public getFileUploadList(): void {
    this.manageUsersService
      .getUserFilesData(this.loginID)
      .subscribe(
        (resolve) => {
          this.documentFiles = resolve;
          if (this.documentFiles.length) {
            this.manageUsersService.updateUserProfileUpdateStr.next(this.documentFiles[0]);
          } else {
            this.manageUsersService.updateUserProfileUpdateStr.next(null);
          }
        },
        (error) => {
          this.alert = {
            type: NOTIFICATION_ERROR,
            message: `${ERROR_OCCURED_TRY_AGAIN_LATER}`,
          };
        }
      );
  }

  public downloadFile(userFile: UserFileUploadDetails): void {
    this.manageUsersService.getUserFileDownload(userFile.id).subscribe(
      (response: UserFileDownload) => {
        const sampleBytes = base64ToArrayBuffer(response.fileContents);
        saveByteArray([sampleBytes], response.fileDownloadName);
      },
      (error) => {
        this.alert = {
          type: NOTIFICATION_ERROR,
          message: `${ERROR_OCCURED_TRY_AGAIN_LATER}`,
        };
      }
    );
  }

  public onBackToWorkFlow(): void {
    if(this.router.url) {
      this.router.navigateByUrl(this.router.url.substr(1, this.router.url.indexOf('/user')).slice(0, -1));
    }
  }

}
